import { ComponentElement, ComponentElementStatic } from "../component_element/ComponentElement.model";
import { ComponentLayoutStatic } from "../template/ComponentLayout.model";


/**
 * 플러그인 타입 정의
 * @since 0.0.1
 * @author Heungsoo,Ham
 * @enum
 */
export enum PluginType {
    /** 이 값으로 확인한 클래스 인스턴스는 COMPONENT ELEMENT 이다 */
    COMPONENTELEMENT = "component element",
    /** 이 값으로 확인한 클래스 인스턴스는 COMPONENT ELEMENT 이다 */
    COMPONENTLAYOUT = "component layout",
    /** 이 값으로 확인한 클래스 인스턴스는 WIH ACTION HANDLER 이다 */
    WIHACTIONHANDLER = "WIH Action handler",
    /** 이 값으로 확인한 클래스 인스턴스는 FORM ACTION HANDLER 이다 */
    FORMACTIONHANDLER = "Form Action handler",
    /** 이 값으로 확인한 클래스 인스턴스는 BLOCK HANDLER 이다 */
    BLOCKHANDLER = "block handler",
    /** 이 값으로 확인한 클래스 인스턴스는 EXCEPTION HANDLER 이다 */
    EXCEPTIONHANDLER = "exception handler",
    /** 이 값으로 확인한 클래스 인스턴스는 MODAL HANDLER 이다 */
    MODALHANDLER = "modal handler",
    /** 이 값으로 확인한 클래스 인스턴스는 TEMPLATE HANDLER 이다 */
    TEMPLATEHANDLER = "template handler",
    /** 이 값으로 확인한 클래스 인스턴스는 CUSTOM HTML HANDLER 이다 */
    CUSTOMHTMLHANDLER = "customHTML handler",
    /** 이 값으로 확인한 클래스 인스턴스는 EMBED FORM HANDLER 이다 */
    EMBEDFORMHANDLER = "embed form handler",
    /** 이 값으로 확인한 클래스 인스턴스는 EMBED PAGE HANDLER 이다 */
    EMBEDPAGEHANDLER = "embed page handler",
    /** 이 값으로 확인한 클래스 인스턴스는 Data Link HANDLER 이다 */
    DATALINKHANDLER = "dataLink handler",
    /** 이 값으로 확인한 클래스 인스턴스는 GRID HANDLER 이다 */
    GRIDHANDLER = "grid handler",
    /** 이 값으로 확인한 클래스 인스턴스는 APP TOOL 이다 */
    APPTOOL = "app tool",
    /** 이 값으로 확인한 클래스 인스턴스는 APP TOOL (MODAL) 이다 */
    APPTOOLMODAL = "app tool modal"
}

/**
 * 플러그인 정보
 * @since 0.0.1
 * @author Heungsoo,Ham
 */
export type PluginInformation<T> = {
    componentElement: {
        [key: string]: ComponentElementStatic<T> & ComponentElement<T>;
    };
    componentLayout: {
        [key: string]: ComponentLayoutStatic;
    };
    appTool: {
        [key: string]: ComponentElementStatic<T> & ComponentElement<T>;
    };
};
